import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0c413d4d = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _24a83bfb = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _8336fabe = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _41f1e4e8 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _73b7443a = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _7d5ef903 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _5fcedfb3 = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _3eb69bba = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _229942a0 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _099342a6 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _52119308 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _7d2be168 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _f78698fa = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _b5dd7616 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _7fff90c8 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _61584d32 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _ce432cec = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _5a3b4f36 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _6ac0beb2 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _0e668393 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _32130dbc = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _3da85326 = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _6ba32a05 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _440b7df8 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _2bb5444e = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _14e89664 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _3255248c = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _3f2015d4 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _e1ec55c6 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _725bf7fe = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _f5ca513c = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _30bed044 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _00deb72f = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _1d8e3682 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _8f2324da = () => interopDefault(import('../../../pages/admin/offers/index.vue' /* webpackChunkName: "pages/admin/offers/index" */))
const _4baa4f6c = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _37b2fb62 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _f7ce87ae = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _664c8803 = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _585884c8 = () => interopDefault(import('../../../pages/offers/constants/index.js' /* webpackChunkName: "pages/offers/constants/index" */))
const _43b23239 = () => interopDefault(import('../../../pages/offers/enums/index.js' /* webpackChunkName: "pages/offers/enums/index" */))
const _45e6e640 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _aca77768 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _f1573ae8 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _6d5ba1ff = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _4e73f52c = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _73ccc76d = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _11fd5dbc = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _0a64389c = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _17906d12 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _411e4745 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _bc7330c2 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _12c7e07a = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _363d60d4 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _71a34828 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _a851dff0 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _ccacd5c2 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _59615db4 = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _1e470002 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _74acc652 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _29ad8569 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _44ebfc4c = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _6fdab8ca = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _359a5006 = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _10d8735c = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _1e96ce0d = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _7629232a = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _12e147e6 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _240cd908 = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _58ef618a = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _418e4d1c = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _9498d576 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _0bcdad64 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _3e1e70d8 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _6d736396 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _77f934f2 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _5d6de773 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _a66cbf28 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _94e1971a = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _31f9c072 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _df8d453c = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _d6733a4a = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _9defab86 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _045a0639 = () => interopDefault(import('../../../pages/offers/_id/agreement/index.vue' /* webpackChunkName: "pages/offers/_id/agreement/index" */))
const _652c3500 = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _72349a94 = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _44633a2f = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _36f875be = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _15ae49e9 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _0c413d4d,
    name: "404-error"
  }, {
    path: "/app",
    component: _24a83bfb,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _8336fabe,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _41f1e4e8,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _73b7443a,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _7d5ef903,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _5fcedfb3,
    name: "comparables"
  }, {
    path: "/contact",
    component: _3eb69bba,
    name: "contact"
  }, {
    path: "/faq",
    component: _229942a0,
    name: "faq"
  }, {
    path: "/favourites",
    component: _099342a6,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _52119308,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _7d2be168,
    name: "listing-management"
  }, {
    path: "/login",
    component: _f78698fa,
    name: "login"
  }, {
    path: "/market-data",
    component: _b5dd7616,
    name: "market-data"
  }, {
    path: "/messages",
    component: _7fff90c8,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _61584d32,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _ce432cec,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _5a3b4f36,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _6ac0beb2,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _0e668393,
    name: "offers"
  }, {
    path: "/privacy",
    component: _32130dbc,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _3da85326,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _6ba32a05,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _440b7df8,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _2bb5444e,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _14e89664,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _3255248c,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _3f2015d4,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _e1ec55c6,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _725bf7fe,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _f5ca513c,
    name: "users"
  }, {
    path: "/whoweare",
    component: _30bed044,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _00deb72f,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _1d8e3682,
    name: "admin-conversation"
  }, {
    path: "/admin/offers",
    component: _8f2324da,
    name: "admin-offers"
  }, {
    path: "/admin/showings",
    component: _4baa4f6c,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _37b2fb62,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _f7ce87ae,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _664c8803,
    name: "login-reset"
  }, {
    path: "/offers/constants",
    component: _585884c8,
    name: "offers-constants"
  }, {
    path: "/offers/enums",
    component: _43b23239,
    name: "offers-enums"
  }, {
    path: "/pro-edit/profile",
    component: _45e6e640,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _aca77768,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _f1573ae8,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _6d5ba1ff,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _4e73f52c,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _73ccc76d,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _11fd5dbc,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _0a64389c,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _17906d12,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _411e4745,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _bc7330c2,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _12c7e07a,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _363d60d4,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _71a34828,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _a851dff0,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _ccacd5c2,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _59615db4,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _1e470002,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _74acc652,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _29ad8569,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _44ebfc4c,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _6fdab8ca,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _359a5006,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _10d8735c,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _1e96ce0d,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _7629232a,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _12e147e6,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _240cd908,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _58ef618a,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _418e4d1c,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _9498d576,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _0bcdad64,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _3e1e70d8,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _6d736396,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _77f934f2,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _5d6de773,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _a66cbf28,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _94e1971a,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _31f9c072,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _df8d453c,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _d6733a4a,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _9defab86,
    name: "listings-id-submit-success"
  }, {
    path: "/offers/:id/agreement",
    component: _045a0639,
    name: "offers-id-agreement"
  }, {
    path: "/settings/:section?/enums",
    component: _652c3500,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _72349a94,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _44633a2f,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _36f875be,
    name: "users-id-section"
  }, {
    path: "/",
    component: _15ae49e9,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
